<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-line" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2" style="font-size: 17px">电车油车对比</span>
          <a v-on:click="oilClick" href="#"><span style="color: deepskyblue">油车</span></a>
          <a v-on:click="electricClick" href="#"><span style="color: #33cea0">电车</span></a>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" v-bind:key="config.data && config.data.length > 0 ? config.data[0][1] : 'default'"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: ['车名', '销量', '能源'],
        data: [
          ['组件1', 1, "<span  class='colorGrass'>↑75%</span>"],
          ['组件2', 'dev-2', "<span  class='colorRed'>↓33%</span>"],
          ['组件3', 'dev-3', "<span  class='colorGrass'>↑100%</span>"],
          ['组件4', 'rea-1', "<span  class='colorGrass'>↑94%</span>"],
          ['组件5', 'rea-2', "<span  class='colorGrass'>↑95%</span>"],
          ['组件6', 'fix-2', "<span  class='colorGrass'>↑63%</span>"],
          ['组件7', 'fix-4', "<span  class='colorGrass'>↑84%</span>"],
          ['组件8', 'fix-7', "<span  class='colorRed'>↓46%</span>"],
          ['组件9', 'dev-2', "<span  class='colorRed'>↓13%</span>"],
          ['组件10', 'dev-9', "<span  class='colorGrass'>↑76%</span>"]
        ],
        rowNum: 7, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        index: true,
        columnWidth: [50],
        align: ['center']
      }
    }
  },
  methods: {
    async electricClick(){
      const res = await this.$http.get('myApp/centerRightChange/0')
      const list = res && res.data && Array.isArray(res.data.realData) ? res.data.realData : []
      if (list.length > 0) {
        this.$set(this.config, 'data', list)
      }
    },
    async oilClick(){
      const res = await this.$http.get('myApp/centerRightChange/1')
      const list = res && res.data && Array.isArray(res.data.realData) ? res.data.realData : []
      if (list.length > 0) {
        this.$set(this.config, 'data', list)
      }
    }
  },
  async mounted() {
    const res = await this.$http.get('myApp/centerRightChange/1')
    const list = res && res.data && Array.isArray(res.data.realData) ? res.data.realData : []
    if (list.length > 0) {
      this.$set(this.config, 'data', list)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/centerRight1.scss';
</style>
